
// react plugin used to create datetimepicker
import ReactDatetime from "react-datetime";
import React from 'react';
import {MDBInput} from "mdb-react-ui-kit";

import {IVR_CAMPAIGN_NAMES,IVR_CAMPAIGN_DOWNLOAD,IVR_CAMPAIGN_LIST} from "../../constants";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
// reactstrap components
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Table,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  UncontrolledTooltip
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';

import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import DatePicker from "../../components/DatePicker/Datepicker.js";


import axios from 'axios';
import { useState,useEffect } from "react";
import moment from "moment";

import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";


const Campaignlist = (props) => {

  const[search,setSearch] = useState({
    name:"",
    date:""
  })
  const[name,setName] = useState([]);
  const[cname,setCName] = useState([]);
  
  const[showList,setShowList] = useState(false);
  const[campignLst,setCampignLst] = useState([]);
  const [currentPage, setCurrentPage] = React.useState(1);

  const[validate,setValidate] = useState({
    message:"",
    notValid:false
  })

  const notificationAlertRef = React.useRef(null);

  const [isLoading, setIsLoading] = React.useState(true);

  const[filterList,setFilterLst] = useState([]);

  useEffect(()=>{
    getCampignNames();
    getCampignList(currentPage);
  },[])

  const getCampignNames=()=>{
    axios.get(IVR_CAMPAIGN_NAMES).then(res=>{
    
      setName(res.data.message);setCName(res.data.message)}).catch(err=>console.log("error===>",err))
  }

  const getCampignList=(page)=>{
  
    setCurrentPage(page);
    axios.get(IVR_CAMPAIGN_LIST+`?page=` +page).then(res=>{
      console.log("--90-",res.data);
      setCampignLst(res.data);
      setIsLoading(false)
      setFilterLst(res.data)
      }).catch(err=>console.log("error===>",err))
  }
  



  const changeName = (e)=>{

    let cmpgnname = e.target.value;
   
    cmpgnname?setShowList(true):setShowList(false)
   
    let namesLiist = cname.filter((item,index)=>item.campaignname.toLowerCase().includes(cmpgnname.toLowerCase()));
    setName(namesLiist)
   
    setSearch({
      ...search,
      name:cmpgnname
    })
    
  }

  const generateXcel=()=>{
   
    if(search?.date&&search?.name){
      
      let selectedDate = moment(search.date).format("YYYY-MM-DD")
      
      axios.get(IVR_CAMPAIGN_DOWNLOAD+`?startdatePickup=`+selectedDate+`&campaignname=`+search.name).then(res=>{exportToCSV(res.data.message);}).catch(err=>{
        let options = {};
    options = {
      place: "tr",
      message: err.response.data.message,
      type: "warning",
     
      autoDismiss: 3
    };
    notificationAlertRef.current.notificationAlert(options);
       })
      
    }else{
      setValidate({
        message:"please enter details",
        notValid:true
      } )

    }
   
  }



const exportToCSV = (apiData) => {
  
  const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(apiData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, search.name + fileExtension);
  
};

const PagingComponent = () => {
  return (
    <>
      {(() => {
        let paging = [];
        paging.push(
          <PaginationItem>
            <PaginationLink
              aria-label="Previous"
              href="#pablo"
              onClick={(e) =>
                currentPage > 1 ? getCampignList(currentPage - 1) : ""
              }
            >
              <span aria-hidden={true}>
                <i
                  aria-hidden={true}
                  className="tim-icons icon-double-left"
                />
              </span>
            </PaginationLink>
          </PaginationItem>
        );
        for (let i = 1; i <= campignLst.numOfPages; i++) {
          paging.push(
            <PaginationItem className={currentPage == i && "active"}>
              <PaginationLink onClick={(e) => getCampignList(i)}>
                {i}
              </PaginationLink>
            </PaginationItem>
          );
        }
        paging.push(
          <PaginationItem>
            <PaginationLink
              aria-label="Next"
              onClick={(e) =>
                currentPage != campignLst.numOfPages
                  ? getCampignList(currentPage + 1)
                  : ""
              }
            >
              <span aria-hidden={true}>
                <i
                  aria-hidden={true}
                  className="tim-icons icon-double-right"
                />
              </span>
            </PaginationLink>
          </PaginationItem>
        );
        return paging;
      })()}
    </>
  );
};

const filterData = (e) =>{
let filter = e.target.value;
let c = parseInt(filter);
// let a = filterList?.message.filter((item,index)=>{console.log(typeof(c)) })
let a = filterList?.message.filter((item,index)=>{return (item.id.toString().includes(filter)||moment(item.campaigndate).format('DD-MM-YYYY').toString().includes(filter))})
setCampignLst({
  message: a,
  numOfPages:filterList.numOfPages
})
console.log("--221--",a);
}
  return (
    
    <>
      <div className="content pb-0">
        {/* <Row>
          <Col md="12">
            <Card className='mb-2'>
              <CardBody>
              <NotificationAlert ref={notificationAlertRef} />
                <Row>
                  <Col md='3' sm="12" className="mt-4">
                  
                  <MDBInput label="name" type="text" value={search.name} onChange={(e)=>changeName(e)} />
                 
                  <ul className="searchScroll">
        {showList&&name?.map((suggestion, index) => (
        
          <li key={index} onClick={()=>{setSearch({...search,name:suggestion.campaignname});setShowList(false);setValidate({
            message:"",
            notValid:false
          } )}}>
            {suggestion.campaignname}
          </li>
        ))}
      </ul>
                  </Col>
                  <Col md='3' sm="12" className="mt-4">
                 
                  <ReactDatetime
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date"
                    }}
                    closeOnSelect={true}
                    timeFormat={false}
                    value={search.date}
                    onChange={(val) =>{setSearch({...search,date:val._d});setValidate({
                      message:"",
                      notValid:false
                    } )}}
                  />
                  </Col>
                  <Col md='4' sm='6' className='pull-right' >
                                
              
                  <Button className=" btn-primary  btn-simple btn-icon btn-round mt-4" 
                  color="primary" 
                   data-placement="top"
                   id="tooltippdf"
                   type="button"
                   onClick={()=>generateXcel()}
                   >
                    <i className="tim-icons icon-cloud-download-93" />
                    
                  </Button>
                  {validate.notValid&&<span style={{color:"red"}}>{validate.message}</span>}
                  <UncontrolledTooltip
                  delay={0}
                  placement="top"
                  target="tooltippdf"
                >
                  Export
                </UncontrolledTooltip>
                  </Col>
                 
                  <Col md='2' sm="12" className="mt-4">
                    <MDBInput label="Search" type="text" onChange={(e)=>filterData(e)} />
                  
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row> */}
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
             
              <CardBody className="mb-0">
              <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
              <TableContainer component={Paper} style={{"height" : "60vh"}}>
      <Table sx={{ minWidth: 650 ,paddingBottom:0}} aria-label="simple table" responsive striped>
        <thead>
         
          <tr >
              <th>S no </th>
              <th >Name  </th>
              <th > CallFlow</th>
              <th > Created on </th>
          </tr>
        </thead>
        <tbody>
          
          {
           
            campignLst?.message?.map((item,index)=>{
              return(
                <>
              <tr>
                <td>{++index}</td>
                <td>{item.campaign_name}</td>
                <td>{item.callflowname}</td>
                <td>{moment(item.campaigndate).format('DD-MM-YYYY')}</td>
              </tr>
              
              </>
              )
            })
          }
        </tbody>
      </Table>
    </TableContainer>
              </CardBody>
              <Row>
              <Col md="12">
                <Pagination className="pull-right">
                  <PagingComponent />
                </Pagination>
              </Col>
            </Row>
            </Card>
          </Col>
         

        </Row>
       
      </div>
    </>
  )
}

export default Campaignlist;